import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class ProductsSlider {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.maxPerView = parseFloat(
            this.root.dataset.productsSliderMax || ''
        );
        this.swiperEl = this.root.querySelector(
            '[data-products-slider-swiper]'
        );
        this.prevEl = this.root.querySelector(
            '[data-products-slider-swiper-prev]'
        );
        this.nextEl = this.root.querySelector(
            '[data-products-slider-swiper-next]'
        );

        this.swiper = null;

        return true;
    }

    init() {
        this.setSwiper();
        window.addEventListener('resize', this.setSwiper);
    }

    setSwiper() {
        if (!this.swiperEl) return;

        if (this.swiperEl.classList.contains('is-single')) {
            if (this.prevEl) this.prevEl.style.display = 'none';
            if (this.nextEl) this.nextEl.style.display = 'none';
            return;
        }

        const totalSlides = this.swiperEl.querySelectorAll('.swiper-slide')
            .length;

        if (totalSlides <= 1) {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
            this.swiperEl.classList.add('is-single');
            if (this.prevEl) this.prevEl.style.display = 'none';
            if (this.nextEl) this.nextEl.style.display = 'none';
            return;
        }

        this.swiperEl.classList.remove('is-single');

        const maxPerView =
            Number.isFinite(this.maxPerView) && this.maxPerView > 0
                ? this.maxPerView
                : null;

        this.swiper = new Swiper(this.swiperEl, {
            modules: [Navigation],
            speed: 650,
            slidesPerView: 1.1,
            spaceBetween: 16,
            breakpoints: {
                640: {
                    slidesPerView: 1.6,
                },
                768: {
                    slidesPerView: 2.2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: maxPerView || 5,
                },
            },
            navigation: {
                prevEl: this.prevEl,
                nextEl: this.nextEl,
            },
            on: {
                init: () => this.toggleNavigation(),
                resize: () => this.toggleNavigation(),
                breakpoint: () => this.toggleNavigation(),
                slideChange: () => this.toggleNavigation(),
                reachBeginning: () => this.toggleNavigation(),
                reachEnd: () => this.toggleNavigation(),
            },
        });
    }

    toggleNavigation() {
        if (!this.swiper || !this.prevEl || !this.nextEl) return;

        const totalSlides = this.swiper.slides.length;
        const perView = this.swiper.slidesPerViewDynamic
            ? this.swiper.slidesPerViewDynamic()
            : this.swiper.params.slidesPerView;

        if (totalSlides <= perView) {
            this.prevEl.style.display = 'none';
            this.nextEl.style.display = 'none';
            return;
        }

        this.prevEl.style.display = this.swiper.isBeginning ? 'none' : '';
        this.nextEl.style.display = this.swiper.isEnd ? 'none' : '';
    }
}

const sections = document.querySelectorAll('[data-products-slider]');
const initProductsSlider = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new ProductsSlider(el);
    });
};

initProductsSlider(sections);
